import { CategoryTemplate } from 'src/app/entities/template';
export class OpenSpace {
    id: number;
    name: string;
    description: string;
    allowProposalsFromDate: Date;
    allowProposalsUntilDate: Date;
    allowVotingFromDate: Date;
    allowVotingUntilDate: Date;
    eventDate: Date;
    maxVotes: number;
    showVotes: boolean;
    showProposer: boolean;
    allowedProposalCreation: boolean;
    categoryTemplateId: number;
    remainingProposingSeconds: number;
    remainingVotingSeconds: number;
  }
